<template>
  <div>
    <div class="d-flex justify-content-between align-items-center pt-50 mb-2">
      <h2 class="font-weight-bolder m-0">
        <span @click="$router.go(-1)">
          <b-button
              variant="white"
              class="btn-icon rounded-circle mr-50 text-primary bg-white"
              size="sm"
          >
            <feather-icon icon="ChevronLeftIcon" />
          </b-button>
        </span> Datos empresa
      </h2>
    </div>
    <b-card class="mb-2" v-if="role == 'super_admin'">
      <b-row>
        <b-col cols="12">
          <p class="font-weight-bold mb-1">Módulos</p>
          <b-form-group :label="'Módulo gestión documental'" label-for="client-module-document" >
            <b-form-checkbox
                v-model="client.document_manager_enabled"
                switch
                :value="1"
                :unchecked-value="0"
                @change="handleModuleChange"
            />
          </b-form-group>
          <b-form-group :label="'Módulo gestión vacaciones'" label-for="client-module-vacation" >
            <b-form-checkbox
                v-model="client.vacation_module_enabled"
                switch
                :value="1"
                :unchecked-value="0"
                @change="handleModuleChange"
            />
          </b-form-group>
          <b-form-group :label="'Habilitar fichaje por QR'" label-for="client-module-qr" >
            <b-form-checkbox
                v-model="client.qr_module_enabled"
                switch
                :value="1"
                :unchecked-value="0"
                @change="handleModuleChange"
            />
          </b-form-group>
          <b-form-group :label="'Privacidad en calendario de compañeros'" label-for="client-module-calendar-privacy" >
            <b-form-checkbox
                v-model="client.calendar_privacy_enabled"
                switch
                :value="1"
                :unchecked-value="0"
                @change="handleModuleChange"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>
    <b-card>
      <validation-observer ref="editClient">
        <b-form
            class="mt-2"
            @submit.prevent="handleSubmit"
            @keydown.enter="handleSubmit"
        >
          <b-row>
            <b-col sm="12">
              <p class="font-weight-bold mb-1">Datos</p>
            </b-col>
            <b-col sm="6">
              <validation-provider
                  #default="{ errors }"
                  name="Nombre"
                  rules="required"
              >
                <b-form-group
                    label="Nombre"
                    label-for="client-name"
                >
                  <b-form-input
                      v-model="client.name"
                      name="name"
                      placeholder="Nombre"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>

            <b-col sm="6">
              <validation-provider
                  #default="{ errors }"
                  name="CIF"
                  rules="required"
              >
                <b-form-group
                    label="CIF"
                    label-for="client-cif"
                >
                  <b-form-input
                      v-model="client.cif"
                      name="reference"
                      placeholder="CIF"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col sm="6">
              <validation-provider #default="{ errors }" name="Dirección">
                <b-form-group label="Dirección" label-for="client-address">
                  <b-form-input
                      v-model="client.address"
                      name="reference"
                      placeholder="Dirección"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col sm="6">
              <validation-provider
                  #default="{ errors }"
                  name="Código postal"
              >
                <b-form-group
                    label="Código postal"
                    label-for="client-postalCode"
                >
                  <b-form-input
                      v-model="client.postalCode"
                      name="reference"
                      placeholder="Código postal"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col sm="6">
              <validation-provider
                  #default="{ errors }"
                  name="Región"
              >
                <b-form-group
                    label="Región"
                    label-for="client-region"
                >
                  <b-form-input
                      v-model="client.region"
                      name="reference"
                      placeholder="Región"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col sm="6">
              <validation-provider
                  #default="{ errors }"
                  name="País"
              >
                <b-form-group
                    label="País"
                    label-for="client-country"
                >
                  <b-form-input
                      v-model="client.country"
                      name="reference"
                      placeholder="País"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col sm="6">
              <validation-provider
                  #default="{ errors }"
                  name="Ciudad"
              >
                <b-form-group
                    label="Ciudad"
                    label-for="client-city"
                >
                  <b-form-input
                      v-model="client.city"
                      name="reference"
                      placeholder="Ciudad"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col sm="6">
              <validation-provider
                  #default="{ errors }"
                  name="Teléfono"
              >
                <b-form-group
                    label="Teléfono"
                    label-for="client-phone"
                >
                  <b-form-input
                      v-model="client.phone"
                      name="reference"
                      placeholder="Teléfono"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col sm="6">
              <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="email"
              >
                <b-form-group
                    label="Email"
                    label-for="client-email"
                >
                  <b-form-input
                      v-model="client.email"
                      name="reference"
                      placeholder="Email"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col sm="6">
              <validation-provider
                  #default="{ errors }"
                  name="Web"
              >
                <b-form-group
                    label="Web"
                    label-for="client-web"
                >
                  <b-form-input
                      v-model="client.web"
                      name="reference"
                      placeholder="Web"
                  />
                </b-form-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col sm="12">
              <b-form-group
                  label="Imagen"
                  label-for="client-image"
              >
                <ImageDropzone
                    v-if="clientPrepare"
                    ref="image"
                    :files="files"
                    max-files="1"
                />
              </b-form-group>
            </b-col>
            <b-col cols="12 text-right">
              <b-button
                  type="submit"
                  variant="primary"
                  class="mt-2 mr-1"
              >
                Guardar
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  BButton,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BCard,
  BFormCheckbox
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import Ripple from 'vue-ripple-directive'
import ImageDropzone from '@/components/elements/ImageDropzone/ImageDropzone.vue'

export default {
  components: {
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    ValidationProvider,
    ValidationObserver,
    ImageDropzone,
    BFormCheckbox
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      files: [],
      required,
      email,
      clientPrepare: false,
    }
  },
  computed: {
    ...mapGetters({
      client: 'clients/getClient',
      currentClient: 'clients/getCurrentClient',
      role: 'auth/getRole',
    }),
  },
  methods: {
    ...mapActions({
      edit: 'clients/edit',
      getClient: 'clients/getClient',
    }),
    handleSubmit() {
      this.$refs.editClient.validate().then(success => {
        if (success) {
          const { id } = this.client
          const formData = this.createFormData()
          if (formData) {
            this.edit({ id, client: formData })
          }
        }
      })
    },
    handleModuleChange() {
      // Simula el envío automático al cambiar un módulo
      this.handleSubmit()
    },
    setData() {
      if (this.client.image) {
        const file = {
          name: 'Image',
          url: this.client.image.path,
          urlDelete: `/clients/delete_image/${this.client.id}`,
        }
        this.files.push(file)
      }

      this.clientPrepare = true
    },
    createFormData() {
      const data = this.$refs.image.getFormData('image')

      data.append('name', this.client.name)
      if (this.role === 'super_admin') {
        data.append('document_manager_enabled', this.client.document_manager_enabled ? this.client.document_manager_enabled : 0)
        data.append('vacation_module_enabled', this.client.vacation_module_enabled ? this.client.vacation_module_enabled : 0)
        data.append('qr_module_enabled', this.client.qr_module_enabled ? this.client.qr_module_enabled : 0)
        data.append('calendar_privacy_enabled', this.client.calendar_privacy_enabled ? this.client.calendar_privacy_enabled : 0)
      }


      data.append('cif', this.client.cif ? this.client.cif : '')
      data.append('address', this.client.address ? this.client.address : '')
      data.append(
          'postalCode',
          this.client.postalCode ? this.client.postalCode : '',
      )
      data.append('region', this.client.region ? this.client.region : '')
      data.append('country', this.client.country ? this.client.country : '')
      data.append('city', this.client.city ? this.client.city : '')
      data.append('phone', this.client.phone ? this.client.phone : '')
      data.append('email', this.client.email ? this.client.email : '')
      data.append('web', this.client.web ? this.client.web : '')

      return data
    },
  },
  async created() {
    await this.getClient(this.currentClient.id)
    await this.setData()
  },
}
</script>
